import React from 'react'
import parse from 'html-react-parser'
import { Video } from '../Video'
import { useBreakpointContext } from '../../util/BreakpointProvider'
import './index.scss'


export function Header({ content }) {
  const { isMobile, isTablet } = useBreakpointContext()

  return (
    <section className = 'inset no-border' >
      <div className='inset'>
        <div className='video-top'>
          <Video src={`https://player.vimeo.com/video/${content.header.video}?background=1`} />
          <h2 className="header-title">{content.header.title}</h2>
          {(isMobile || isTablet) ? null : (
            <OverlayContent
              summary={content.header.summary}
              items={content.header.items}
              isMobile={isMobile}
              isTablet={isTablet}
            />
          )}
        </div>
        {(isMobile || isTablet) && (
          <OverlayContent
            summary={content.header.summary}
            items={content.header.items}
            isMobile={isMobile}
            isTablet={isTablet}
          />
        )}
      </div>
      </section >

  )
}

function OverlayContent({ summary, items, isMobile, isTablet }) {
  return (
    <div className="overlay-content vstack">
      <p>{summary}</p>
      <div className="stats-line">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <span>{parse(item.text)}</span>
            {(isMobile || isTablet) && index < items.length - 1 && (
              <div className="divider" />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
} 